module.exports = __webpack_public_path__ + "img/1731.74bab7eb.gif";